
import { GET_BRAINCHIP_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_BRAINCHIP_TYPES_SUCCESS: {
      const brainchipTypes = action.payload;

      if (!brainchipTypes){
        return [...state];
      }

      return [
        ...state,
        ...brainchipTypes
      ]
    }
    default:
      return state;
  }
}
